<template>
  <div :class="`${baseClass}-header-container px-6 py-4`">
    <div :class="`${baseClass}-header d-flex justify-space-between align-center`">
      <!-- Header text block -->
      <div :class="`${baseClass}-header-text`">
        <h2 :class="`${baseClass}-title text-h6 font-weight-semibold d-flex align-center mb-1`">
          <v-icon :class="`mr-2 ${baseClass}-title-icon`">{{ icon }}</v-icon>
          {{ title }}
        </h2>
        <p v-if="subtitle" :class="`${baseClass}-subtitle text-body mb-0`">
          {{ subtitle }}
        </p>
      </div>

      <!-- Optional header controls (e.g. timeframe select, buttons) -->
      <div v-if="$slots.controls">
        <slot name="controls" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',

  props: {
    baseClass: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>

/* Uncomment to see the border */
/* 
[class*="-header-container"] {
  border-bottom: 1px solid #e5e7eb;
} 
*/

[class*="-header-text"] {
  flex: 1;
  min-width: 0;
  margin-right: 16px;
}

[class*="-title"] {
  color: #1f2937;
}

[class*="-title-icon"] {
  color: #6b7280;
}

[class*="-subtitle"] {
  color: #6b7280;
  font-size: 13px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 100%;
  line-height: 1.5;
}
</style>

